module.exports = __webpack_public_path__ + "static/media/01C.6da553d4.png";